import { useState } from "react";

export default function FloatingWhatsApp() {
  const [showTooltip, setShowTooltip] = useState(false);

  const whatsappNumber = "905323953104";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Merhaba%2C%20Plaj%20Cadde%20Tekel%27den%20bilgi%20almak%20istiyorum.`;

  return (
    <>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full transition-all duration-300 hover:scale-110 cursor-pointer shadow-lg group"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
        {showTooltip && (
          <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-foreground-900 text-background-50 text-xs md:text-sm px-3 py-2 rounded-lg whitespace-nowrap">
            WhatsApp: 0532 395 31 04
            <span className="absolute left-full top-1/2 -translate-y-1/2 border-4 border-transparent border-l-foreground-900"></span>
          </span>
        )}
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary-500 rounded-full border-2 border-background-50 animate-pulse"></span>
      </a>
    </>
  );
}